module.exports = __webpack_public_path__ + "static/media/Lockton_Marine_P&I_skuld.27ab1699.pdf";